<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref, defineProps, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'

import { useRouter } from 'vue-router';
const router = useRouter();

const goNextPage = () => {
    router.push({ name: 'cloudCounterReserveTime' });
}


// 要保人電話
const applicantPhone = ref('');

// 被保險人有變更
const assuredRequired = ref(true);

// 被保險人電話
const assuredPhone = ref('');


</script>

<template>

    <Layout :header="{ text: '要保人或被保險人姓名變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', '視訊預約',]" :index="3"></Process>
        </div>

        <div class="pb-8">
            <h2 class="font-bold text-2xl">
                預約視訊驗證
            </h2>
            <p class="pt-2">本公司將發送視訊連結至以下留存之行動電話，若資訊不正確，請與您的服務人員聯繫或致電本公司0809-000-550辦理行動電話變更。</p>
        </div>

        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                發送簡訊之行動電話
            </h3>
            <ul>
                <li class="pb-4">
                    <h5 class="font-bold text-md pb-2">
                        要保人：林大富
                    </h5>
                    <input class="w-full" type="text" v-model="applicantPhone" placeholder="請輸入行動電話">
                    <p class="pt-2">同時變更以您為要保人於本公司投保之所有個人險有效及停效保單</p>
                </li>
                <li v-if="assuredRequired">
                    <h5 class="font-bold text-md pb-2">
                        被保險人：林小邦
                    </h5>
                    <input class="w-full" type="text" v-model="assuredPhone" placeholder="請輸入行動電話">
                    <p class="pt-2">同時變更您本次預約申請的保單之被保險人行動電話</p>
                </li>
            </ul>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="applicantPhone === '' || ((assuredRequired) ? (assuredPhone === '') : false)"
                @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>
